
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shoppingguide/[slug]",
      function () {
        return require("private-next-pages/shoppingguide/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shoppingguide/[slug]"])
      });
    }
  